export let countriesRename = new Map([
  ["Antigua and Barbuda", "Antigua and Barb."],
  ["Bahamas, The", "Bahamas"],
  ["Bosnia and Herzegovina", "Bosnia and Herz."],
  ["Brunei Darussalam", "Brunei"],
  ["Central African Republic", "Central African Rep."],
  ["Cote d'Ivoire", "Côte d'Ivoire"],
  ["Congo, Dem. Rep.", "Dem. Rep. Congo"],
  ["Congo, Rep.", "Congo"],
  ["Czech Republic", "Czechia"],
  ["Dominican Republic", "Dominican Rep."],
  ["Egypt, Arab Rep.", "Egypt"],
  ["Micronesia, Fed. Sts.", "Micronesia"],
  ["Gambia, The", "Gambia"],
  ["Equatorial Guinea", "Eq. Guinea"],
  ["Iran, Islamic Rep.", "Iran"],
  ["Kyrgyz Republic", "Kyrgyzstan"],
  ["Korea, Rep.", "South Korea"],
  ["Lao PDR", "Laos"],
  ["St. Lucia", "Saint Lucia"],
  ["Marshall Islands", "Marshall Is."],
  ["North Macedonia", "Macedonia"],
  ["Korea, Dem. People's Rep.", "North Korea"],
  ["Russian Federation", "Russia"],
  ["Solomon Islands", "Solomon Is."],
  ["South Sudan", "S. Sudan"],
  ["Sao Tome and Principe", "São Tomé and Principe"],
  ["Slovak Republic", "Slovakia"],
  ["Eswatini", "eSwatini"],
  ["Syrian Arab Republic", "Syria"],
  ["Tuvalu", null],
  ["United States", "United States of America"],
  ["St. Vincent and the Grenadines", "St. Vin. and Gren."],
  ["Venezuela, RB", "Venezuela"],
  ["World", null],
  ["Yemen, Rep.", "Yemen"],
]);

export let countriesRenameReverse = new Map(
  Array.from(countriesRename, (d) => d.reverse())
);
